import { render } from "./AcquisitionQuickPanel.vue?vue&type=template&id=6e947ff1&scoped=true"
import script from "./AcquisitionQuickPanel.vue?vue&type=script&lang=js"
export * from "./AcquisitionQuickPanel.vue?vue&type=script&lang=js"

import "./AcquisitionQuickPanel.vue?vue&type=style&index=0&id=6e947ff1&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e947ff1"]])

export default __exports__